<template lang="jade">
  include ./mixin.jade
  +simpleGetButton('dxGetAVQosSettings')
  +simpleGetButton('dxGetSysInfo')
  +simpleGetButton('dxGetPortStatus')
</template>

<style scoped>
  .thin {
    width: 16%;
  }
</style>
<script>
  export default {
    data: () => {
      return {}
    },
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSetOutputResolution () {
        this.sendAPI('dxSetOutputResolution', {
          resolution: {
            [this.outputRes.port]: this.outputRes.option
          }
        })
      },
      dxSetSplitArea () {
        this.sendAPI('dxSetSplitArea', {
          setting: this.splitArea
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// mes.vue?634339da